import { useCallback } from 'react';
import { onRequestMade } from '../../common/analytics';
import { type PostQuerySupplierArgs, type SearchItems } from '../product-router';
import { useCommonContext } from '../product-router/product/result-provider/analytics/product-state-analytics/use-product-state-analytics';

export const useDecorateWithTimings = () => {
	const [fireAnalyticsEvent, activeProduct, isExpanded, isMultiProduct, filters] =
		useCommonContext();

	const decorateWithTimings = useCallback(
		(postQueryItemSupplier: (args: PostQuerySupplierArgs) => Promise<SearchItems>) => {
			return (args: PostQuerySupplierArgs) => {
				const start = new Date();
				return postQueryItemSupplier(args).then((result: SearchItems) => {
					const end = new Date();
					const postQueryRequestDurationMs = end.getTime() - start.getTime();
					fireAnalyticsEvent(
						onRequestMade({
							actionSubjectId: 'postQuerySearchResults',
							timings: { postQueryRequestDurationMs },
							activeProduct: activeProduct?.id,
							isExpanded,
							isMultiProduct,
							filters,
						}),
					);
					return result;
				});
			};
		},
		[fireAnalyticsEvent, activeProduct?.id, isExpanded, isMultiProduct, filters],
	);
	return decorateWithTimings;
};
